import React from 'react';
import { AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';

interface AlertProps {
  type: 'error' | 'success' | 'warning' | 'info';
  message: string;
  className?: string;
}

export const Alert: React.FC<AlertProps> = ({ type, message, className = '' }) => {
  const getAlertStyles = () => {
    switch (type) {
      case 'error':
        return {
          container: 'bg-error-50 border-error-200 text-error-700',
          icon: AlertCircle,
        };
      case 'success':
        return {
          container: 'bg-success-50 border-success-200 text-success-700',
          icon: CheckCircle,
        };
      case 'warning':
        return {
          container: 'bg-warning-50 border-warning-200 text-warning-700',
          icon: AlertTriangle,
        };
      case 'info':
        return {
          container: 'bg-blue-50 border-blue-200 text-blue-700',
          icon: Info,
        };
      default:
        return {
          container: 'bg-gray-50 border-gray-200 text-gray-700',
          icon: Info,
        };
    }
  };

  const { container, icon: Icon } = getAlertStyles();

  return (
    <div className={`border px-4 py-3 rounded-lg flex items-start space-x-2 ${container} ${className}`}>
      <Icon className="w-5 h-5 mt-0.5 flex-shrink-0" />
      <span className="text-sm">{message}</span>
    </div>
  );
};